module.exports = __webpack_public_path__ + "media/images/news/whatsapp-web-ef1e4c1f3a902c6b600860fbbc1e83b5.gif";